var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 14.725,
    viewBox: "0 0 27 14.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M13.5,14.283a11.1,11.1,0,0,1,4.77,1.1,3.693,3.693,0,0,1,1.98,3.35v1.988H6.75V18.749A3.667,3.667,0,0,1,8.73,15.4,10.929,10.929,0,0,1,13.5,14.283Zm-9,.307a2.366,2.366,0,0,0,2.25-2.454A2.366,2.366,0,0,0,4.5,9.681a2.366,2.366,0,0,0-2.25,2.454A2.366,2.366,0,0,0,4.5,14.59Zm1.271,1.35A7.22,7.22,0,0,0,4.5,15.817a7.268,7.268,0,0,0-3.127.712A2.483,2.483,0,0,0,0,18.8v1.927H5.063V18.749A5.9,5.9,0,0,1,5.771,15.939ZM22.5,14.59a2.366,2.366,0,0,0,2.25-2.454A2.366,2.366,0,0,0,22.5,9.681a2.366,2.366,0,0,0-2.25,2.454A2.366,2.366,0,0,0,22.5,14.59ZM27,18.8a2.483,2.483,0,0,0-1.372-2.27,7.055,7.055,0,0,0-4.4-.589,5.9,5.9,0,0,1,.709,2.81v1.976H27ZM13.5,6a3.533,3.533,0,0,1,3.375,3.681A3.533,3.533,0,0,1,13.5,13.362a3.533,3.533,0,0,1-3.375-3.681A3.533,3.533,0,0,1,13.5,6Z",
    transform: "translate(0 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStudents);
export default __webpack_public_path__ + "static/media/icon_students.e7357fc29edeb2fc6c67b01eebbf8b17.svg";
export { ForwardRef as ReactComponent };